import React, { useEffect, useState } from "react";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import { FormProvider, useForm } from "react-hook-form";
import classes from "./Users.module.scss";
import Input from "../../../../components/Common/Input/Input";
import DistributeButton from "../../DistributeButton/DistributeButton";
import { useDispatch } from "react-redux";
import { getUsersActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { useOutletContext } from "react-router";
import { injectIntl } from "react-intl";
import { getUserByNameInGroupManagementActionHandler } from "../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";

const Users = ({ intl }) => {
  const dispatch = useDispatch();
  const { tenantName, setLoading } = useOutletContext();
  const methods = useForm({});
  const {
    reset,
    formState: { isDirty },
  } = methods;
  const [users, setUsers] = useState([]);
  const [originalSetOfUsers, setOriginalSetOfUsers] = useState([]);
  const [usersLoader, setUsersLoader] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);

  useEffect(() => {
    dispatch(
      getUsersActionHandler(setUsers, setUsersLoader, setOriginalSetOfUsers)
    );
  }, [dispatch]);

  const handleTagList = (tagList) => {
    let removedIds = [];
    const updatedData = tagList?.filter((item) => {
      if (!item?.checked) removedIds.push(item?.Id);
      return item?.checked;
    });
    setUsers(tagList);
    setSelectedUser((prevState) => {
      const newSelectedUsers = [...prevState, ...updatedData];
      let uniqueSelectedUsers;

      // Ensure the array contains only unique values
      uniqueSelectedUsers = Array.from(
        new Set(newSelectedUsers.map((user) => user.Id))
      ).map((id) => newSelectedUsers.find((user) => user.Id === id));

      // Remove objects from uniqueSelectedUsers by checking against removedIds
      if (removedIds?.length > 0) {
        uniqueSelectedUsers = uniqueSelectedUsers.filter(
          (user) => !removedIds.includes(user.Id)
        );
      }

      if (uniqueSelectedUsers?.length > 0) {
        let selectedUserIds = uniqueSelectedUsers?.map((selectUser) => {
          return selectUser?.Id;
        });

        const updatedUser = originalSetOfUsers?.map((user) => {
          if (selectedUserIds?.includes(user?.Id)) {
            return {
              ...user,
              checked: true,
              Name: user?.FirstName + " " + user?.LastName,
              Id: user?.Id,
            };
          } else
            return {
              ...user,
              Name: user?.FirstName + " " + user?.LastName,
              checked: false,
            };
        });
        setUsers(updatedUser);
      }

      return uniqueSelectedUsers;
    });

    if (updatedData?.length === 0) {
      setUsers(originalSetOfUsers);
    }
  };

  const resetForm = () => {
    reset();
    const updatedData = users?.map((data) => {
      return {
        ...data,
        checked: false,
        Name: data?.FirstName + " " + data?.LastName,
      };
    });
    setUsers(updatedData);
    setSelectedUser([]);
  };

  const onChange = (val) => {
    let selectedUserIds = [];
    if (selectedUser?.length > 0) {
      selectedUserIds = selectedUser?.map((selectUser) => {
        return selectUser?.Id;
      });
    }
    if (!val) {
      if (selectedUser?.length > 0) {
        const updatedUser = originalSetOfUsers?.map((user) => {
          if (selectedUserIds?.includes(user?.Id)) {
            return {
              ...user,
              checked: true,
              Name: user?.FirstName + " " + user?.LastName,
              Id: user?.Id,
            };
          } else
            return {
              ...user,
              Name: user?.FirstName + " " + user?.LastName,
              checked: false,
            };
        });
        setUsers(updatedUser);
      } else setUsers(originalSetOfUsers);
    } else
      dispatch(getUserByNameInGroupManagementActionHandler(val)).then((res) => {
        if (res?.status === 200 && res?.data) {
          const updatedData = res?.data?.map((item) => {
            if (
              selectedUser?.length > 0 &&
              selectedUserIds?.includes(item?.ID)
            ) {
              return {
                Name: item?.FirstName + " " + item?.LastName,
                FirstName: item?.FirstName,
                LastName: item?.LastName,
                LoginId: item?.LoginId,
                isVisible: true,
                checked: true,
                Id: item?.ID,
              };
            } else
              return {
                Name: item?.FirstName + " " + item?.LastName,
                FirstName: item?.FirstName,
                LastName: item?.LastName,
                LoginId: item?.LoginId,
                isVisible: true,
                checked: false,
                Id: item?.ID,
              };
          });
          setUsers(updatedData);
        }
      });
  };

  return (
    <BoxLayout>
      <div className={classes.users}>
        <FormProvider {...methods}>
          <Input
            label="Choose Users"
            name="user"
            fieldName={"Name"}
            fieldValue="LoginId"
            type="noSearchTags"
            placeholder={intl.formatMessage({
              id: `ANALYTICAL_SEARCH_USER_TEXT`,
            })}
            labelColor={"light"}
            width="27"
            height="5"
            loading={usersLoader}
            searchTagsList={users || []}
            handleTagList={(tagList) => handleTagList(tagList)}
            searchable
            onInputChange={(val) => onChange(val)}
          />
        </FormProvider>
      </div>
      <DistributeButton
        selectedUser={selectedUser}
        resetForm={resetForm}
        tenantName={tenantName}
        distributedTo={3}
        isDirty={isDirty}
        setLoading={setLoading}
      />
    </BoxLayout>
  );
};

export default injectIntl(Users);
